import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/index";
import PageContainer from "./assets/containers/PageContainer";
import ProfilePage from "./pages/Profile";
import QuestionContainer from "./pages/MatchPage/questions/questionContainer";
import Questions from "./pages/MatchPage/questions";
import MatchQuests from "./pages/MatchPage/quests";
import LeaderBoardPage from "./pages/LeaderBoard";
import Login from "./pages/Login";
import NotFound from "./pages/notFound";
import { useLocation } from "react-router-dom";
import useLocalStorage from "./assets/Hooks/getLocalStorageData";
import AccessCheck from "./pages/AccessCheck";
import AccessCheckV2 from "./pages/AccessCheckV2";
import AccessCheckV3 from "./pages/AccessCheckV3";
import UpdateUser from "./pages/UpdateUser";
import ForgetPass from "./pages/Login/ForgetPass";
import Blog from "./pages/blog";
import MatchKhazaneh from "./pages/MatchPage/quests/khazane";
import MiniMatch from "./pages/MatchPage/MiniMatch";
import FortuneWhile from "./pages/FortuneWhile";
import Lig from "./pages/Lig";
import LigMap from "./pages/Lig/LigMap";
import LigLeaderBoard from "./pages/Lig/LigLeaderBoard";
import ChallengeList from "./pages/Lig/LigChallengeList";
import ArchivePage from "./pages/Home/Archive";
import EventsPage from "./pages/EventsPage";
import EventSections from "./pages/EventsPage/eventSections/EventSections";
import Ticket from "./pages/EventsPage/Ticket";
import ProtectedRoute from "./assets/containers/RestrictedRouteContainer";
import Gallery from "./pages/Gallery";
import Dashboard from "./pages/DashBoard";
import MatchMainDashbaord from "./pages/MatchPage/dashboard";
import ScoreHistroy from "./pages/MatchPage/socreHistory";
import Roshana from "./pages/Roshana/index";
import RoshanaMoharam from "./pages/Roshana/RoshanaMoharam";
import PreMatch from "./pages/MatchPage/PreMatch";
import useIsMobile from "./assets/Hooks/getIsMobile";
import MainFooter from "./assets/components/mainFooter";
import RB from "./pages/RB";
import { useSelector } from "react-redux";
import RBCatalog from "./pages/RB/RBCatalog";
import RBBlog from "./pages/RB/rbBlog";
import RbVow from "./pages/RB/RbVow";
import FormsList from "./pages/Forms";
import FillForm from "./pages/Forms/FillForm";
import ReportCards from "./pages/ReportCards";
import ReportCardDetails from "./pages/ReportCards/ReportCardDetails";
import FormQR from "./pages/Forms/FormQR";
import GoldenCard from "./pages/MatchPage/goldenCard";
import PointShop from "./pages/PointShop";
import PointsShopDetails from "./pages/PointShop/PointsShopDetails";
import AwardRreceipt from "./pages/PointShop/AwardRreceipt";
import PurchaseList from "./pages/PointShop/PurchaseList";
import Transactions from "./pages/PointShop/Transactions";
import EventDetails from "./pages/EventsPage/eventDetails/EventDetails";
import PeleBaroon from "./pages/MatchPage/PeleBaroon";
import { CreateTicket, CreatedTicket } from "./pages/Ticket";
import ContractingStores from "./pages/Forms/ContractingStores";
import WordGamesList from "./pages/wordGamesList";
import PdfViewer from "./pages/PdfViewer";

import {
  HableDashBoard,
  HubbleScoreBoard,
  HubbleBlog,
  HubbleMap,
  Upload,
  Majors,
  MyUploads,
  CompressEducation,
  UploadsArbitration,
  Judge,
} from "./pages/Habel";
import {
  WordGame,
  WordGamePreview,
  EventWordGamePreview,
} from "./pages/MatchPage/WordGame";
// import RB1404Loader from "./pages/RB1404";

export default function AppRoutes() {
  const location = useLocation();
  const { fcm } = useLocalStorage();
  const { hideHeader_footer } = useSelector(({ common }) => common);
  const isMobile = useIsMobile();
  const isDesktopHome = useMediaQuery("(min-width: 992px)") && location.pathname === "/";

  return (
    <>
      <Routes key={location.pathname} location={location}>
        <Route
          path="/"
          element={<PageContainer fcm={fcm === null ? "" : fcm} />}
        >
          <Route path="/" exact element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/pdf/:fileName" element={<PdfViewer />} />
          <Route path="/dashboard" exact element={<Dashboard />} />
          <Route path="/acess/check/" element={<AccessCheck />} />
          <Route path="/acessv2/check/" element={<AccessCheckV2 />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contractingStores" element={<ContractingStores />} />
          <Route path="/createTicket" element={<CreateTicket />} />
          <Route path="/createdTicket/:id" element={<CreatedTicket />} />
          {/* <Route path="/rb1404/*" element={<RB1404Loader />} /> */}
          <Route element={<ProtectedRoute />}>
            <Route path="/acessv3/check/" element={<AccessCheckV3 />} />
            <Route path="/forgetPass" element={<ForgetPass />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/match" element={<MatchMainDashbaord />} />
            <Route path="/match/:id" element={<MiniMatch />} />
            <Route path="/questions/:matchId" element={<Questions />} />
            <Route path="/question/:id" element={<QuestionContainer />} />
            <Route path="/leaderboard" element={<LeaderBoardPage />} />
            <Route path="/quests" element={<MatchQuests />} />
            <Route path="/khazane/:id" element={<MatchKhazaneh />} />
            <Route path="/preMatch/:id" element={<PreMatch />} />
            <Route path="/user/update" element={<UpdateUser />} />
            <Route path="/fortuneWheel" element={<FortuneWhile />} />
            <Route path="/goldenCard" element={<GoldenCard />} />
            <Route path="/lig" element={<Lig />} />
            <Route path="/lig/map" element={<LigMap />} />
            <Route path="/lig/leaderBoard" element={<LigLeaderBoard />} />
            <Route path="/peleBaroon" element={<PeleBaroon />} />
            <Route
              path="/lig/challenges/:messionNumber"
              element={<ChallengeList />}
            />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:eventId" element={<EventSections />} />
            <Route path="/eventDetails/:id" element={<EventDetails />} />
            <Route path="/ticket/:ticketId" element={<Ticket />} />
            <Route path="/scoreHistory" element={<ScoreHistroy />} />
            <Route path="/scoreHistory/:id" element={<ScoreHistroy />} />
            <Route path="/roshana" element={<Roshana />} />
            <Route path="/mRoshana" element={<RoshanaMoharam />} />
            <Route path="/rb1403" element={<RB />} />
            <Route path="/rb1403/catalog" element={<RBCatalog />} />
            <Route path="/rb1403/blog" element={<RBBlog />} />
            <Route path="/rb1403/vow" element={<RbVow />} />
            <Route path="/forms" element={<FormsList />} />
            <Route path="/reportcards" element={<ReportCards />} />
            <Route path="/reportcard/:id" element={<ReportCardDetails />} />
            <Route path="/form/:id" element={<FillForm />} />
            <Route path="/formQR/:id" element={<FormQR />} />
            <Route path="/pointShop" element={<PointShop />} />
            <Route path="/awardReceipt/:id" element={<AwardRreceipt />} />
            <Route path="/purchaseList" element={<PurchaseList />} />
            <Route
              path="/pointShopDetails/:id"
              element={<PointsShopDetails />}
            />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/hubble" element={<HableDashBoard />} />
            <Route path="/hubble/scoreBoard" element={<HubbleScoreBoard />} />
            <Route path="/hubble/blog" element={<HubbleBlog />} />
            <Route path="/hubble/map" element={<HubbleMap />} />
            <Route path="/hubble/upload" element={<Upload />} />
            <Route path="/hubble/majors" element={<Majors />} />
            <Route path="/hubble/compressEd" element={<CompressEducation />} />
            <Route
              path="/hubble/UploadsArbitration"
              element={<UploadsArbitration />}
            />
            <Route path="/hubble/myUploads" element={<MyUploads />} />
            <Route path="/hubble/judge/:id" element={<Judge />} />
            <Route path="/hubble/judge/edit/:id" element={<Judge />} />
            <Route path="/hubble/upload/edit/:id" element={<Upload />} />
            <Route path="/wordGame" element={<WordGamePreview />} />
            <Route path="/wordGame/:id" element={<WordGame />} />
            <Route path="/wordGamesList" element={<WordGamesList />} />
            <Route path="/eventWordGame/:id" element={<EventWordGamePreview />} />
          </Route>
          <Route path="/login" element={<Login />} />
        </Route>
        <Route
          path="/404"
          element={<NotFound fcm={fcm === null ? "" : fcm} />}
        />
        <Route path="*" element={<NotFound fcm={fcm === null ? "" : fcm} />} />
      </Routes>
      {location.pathname !== "/lig/map" &&
        location.pathname !== "/leaderboard" &&
        location.pathname !== "/scoreHistory" &&
        !location.pathname.includes("scoreHistory") &&
        isMobile &&
        !isDesktopHome &&
        !hideHeader_footer && <MainFooter />}
    </>
  );
}
